import { TFunction } from 'i18next';
import { CustomCells } from '@components-clean/core/grid/custom-cell';
import { GridColumnProps } from '@components-clean/core/grid/grid.interface';
import { DateCell } from '@components-clean/core/grid-fe/custom-cells';

export const MANAGE_SIGNATORIES_GRID_COLUMNS = (t: TFunction, customCells: CustomCells): GridColumnProps[] => {
    const { TooltipCell } = customCells;
    const nameAndJobCols: GridColumnProps[] = [
        {
            field: 'firstName',
            title: t('firstName'),
            id: 'signatory-first-name',
            minWidth: 208,
            cells: {
                data: TooltipCell({
                    isCsv: false,
                    maxLines: 2,
                }),
            },
        },
        {
            field: 'lastName',
            title: t('lastName'),
            id: 'signatory-last-name',
            minWidth: 208,
            cells: {
                data: TooltipCell({
                    isCsv: false,
                    maxLines: 2,
                }),
            },
        },
        {
            field: 'jobTitle',
            title: t('reports:jobTitle'),
            id: 'signatory-job-title',
            minWidth: 208,
            cells: {
                data: TooltipCell({
                    isCsv: false,
                    maxLines: 2,
                }),
            },
        },
    ];

    const generatedDateAndByCols: GridColumnProps[] = [
        {
            field: 'createdByName',
            title: t('ra:createdBy'),
            id: 'signatory-created-by',
            showByDefault: false,
            minWidth: 140,
        },
        {
            field: 'createdDate',
            title: t('ra:createdDate'),
            id: 'signatory-created-date',
            showByDefault: false,
            minWidth: 120,
            cells: {
                data: DateCell,
            },
            filter: 'date',
            cellName: 'DateCell',
        },
        {
            field: 'updatedByName',
            title: t('ra:updatedBy'),
            id: 'signatory-updated-by',
            showByDefault: false,
            minWidth: 140,
        },
        {
            field: 'updatedDate',
            title: t('ra:updatedDate'),
            id: 'signatory-updated-date',
            showByDefault: false,
            minWidth: 120,
            cells: {
                data: DateCell,
            },
            filter: 'date',
            cellName: 'DateCell',
        },
    ];

    const recordIdCol: GridColumnProps = {
        field: '_itemId',
        title: t('id'),
        minWidth: 50,
        id: 'signatory-id',
        showByDefault: false,
    };

    return [...nameAndJobCols, ...generatedDateAndByCols, recordIdCol];
};
